import { Heading } from '../../r2/Heading';
import { Text } from '../../r2/Text';
import { Image } from '../../r2/Image';
import styles from './FeatureCard.module.css';

export interface FeatureCardProps {
  imageSrc: string;
  imageAlt: string;
  title: string;
  description: string;
}

export function FeatureCard({
  imageSrc,
  imageAlt,
  title,
  description,
}: FeatureCardProps) {
  return (
    <div data-crd-id="r3.bq-feature-card" data-crd-layer="r3" className={styles.card}>
      <Image
        src={imageSrc}
        alt={imageAlt}
        width={175}
        loading="lazy"
        className={styles.image}
      />
      <div className={styles.content}>
        <Heading level={3} as={3}>
          {title}
        </Heading>
        <Text size="r1">{description}</Text>
      </div>
    </div>
  );
}
